// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/UsuarioPermissoesUpdateNestedInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import { registerContract } from './validate'

export interface UsuarioPermissoesUpdateNestedInput {
user_id: number
permissions?: string[]
}

registerContract('UsuarioPermissoesUpdateNestedInput', {
  user_id:     { type: 'number',  required: true },
  permissions: { type: 'array',   required: false },
})
